import classNames from 'classnames';

import { SecuritySettingModalNames } from '@/components/SecuritySettingModalManager';
import { useI18nContext } from '@/i18n/I18n';
import { useSecuritySettingModal } from '@/store/useSecuritySettingModal/useSecuritySettingModal';
import { useSecuritySettingModalData } from '@/store/useSecuritySettingModal/useSecuritySettingModalData';

import { ArrowIcon } from './arrow';
import ErrorIcon from './icons/errorIcon.svg';
import SuccessIcon from './icons/successIcon.svg';
import WarningIcon from './icons/warnIcon.svg';

const colors = ['', 'var(--bds-red-700-normal)', '#d6850d', '#20b26c'];

const Icons = ['', ErrorIcon, WarningIcon, SuccessIcon];

const SecurityItem = ({
  item,
  security_level,
}: {
  item: any;
  security_level: number;
}) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [$t] = useI18nContext();
  const { openSecuritySettingModal } = useSecuritySettingModal();
  const { getAntiPhishing, checkGoogleUnderReview } =
    useSecuritySettingModalData();

  const textObj: { [key: string]: string } = {
    Email: $t('Email Address New'),
    Mobile: $t('Mobile Phone'),
    Ga: $t('Google 2FA Authentication New'),
    Kyc: $t('kycAuth'),
    AntiPhishingCode: $t('AntiPhishingCode'),
    WithdrawalLimitSwitch: $t('Withdrawal Security'),
    PaymentPassword: $t('fundPassword'),
  };
  const statusClass = item.is_bound ? 'bind-success' : 'need-bind';
  const clickHandler = () => {
    // setEvent(item.name.toLowerCase());
    if (item.name === SecuritySettingModalNames.AntiPhishingModal) {
      getAntiPhishing();
    }
    if (item.name === SecuritySettingModalNames.Ga) {
      checkGoogleUnderReview();
    }
    openSecuritySettingModal(item.name);
  };

  console.info(security_level, '---- security_level ----');

  return (
    <span
      className={classNames(statusClass, {
        'lower-status': security_level === 1,
        'middle-status': security_level === 2,
        'high-status': security_level === 3,
      })}
      onClick={clickHandler}
    >
      {item.is_bound ? <img src={SuccessIcon} alt="" /> : <></>}
      {!item.is_bound && <img src={Icons[security_level]} alt="" />}
      <span
        style={{ color: item.is_bound ? colors[3] : colors[security_level] }}
      >
        {textObj[item.name]}
      </span>

      <ArrowIcon color={item.is_bound ? colors[3] : colors[security_level]} />
    </span>
  );
};

export default SecurityItem;
